import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
var MobileHeaderwithBackAndCancel = function MobileHeaderwithBackAndCancel(props) {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "relative sticky top-0 flex items-center justify-center border-b border-solid border-[#dae5f4] bg-white p-[23px]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute top-1/2 -translate-y-1/2 rtl:right-5 ltr:left-5 ltr:-scale-x-100",
    onClick: function onClick() {
      return props.backFunction();
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/arrow_right.svg",
    alt: "arrow"
  })), /*#__PURE__*/React.createElement("span", {
    className: "absolute top-1/2 -translate-y-1/2 text-sm leading-6 text-[#6c7a8d] rtl:left-5 ltr:right-5",
    onClick: function onClick() {
      return props.buttonFunction();
    }
  }, t("cancel", {
    ns: "web_checkout_cash"
  })));
};
export default MobileHeaderwithBackAndCancel;